/* ==========================================================
   feel-quiz.js
   Used on: templates/page.quiz.json → sections/feel-quiz.liquid
   Source: _mockups/01_ALL_HTML_MOCKUPS/quiz.html (lines 1699-2132)

   Shopify adaptations vs mockup:
   - Product data (variantId, imageUrl, handle, rating) injected by Liquid
     via <script id="quiz-product-data" type="application/json">
   - Quick shop: direct cart add via /cart/add.js, then open cart drawer
   - Checkout CTA: POST to /cart/add.js multi-item, then open cart drawer
   - Email form: Shopify newsletter form (handled by Liquid)
   ========================================================== */

(function () {
  "use strict";

  var S = window.FA_QUIZ_STRINGS || {};

  // ----------------------------------------------------------
  // STATIC PRODUCT CATALOG — content / scoring data
  // Prices and variantIds will be overwritten from Liquid injection
  // ----------------------------------------------------------
  var PRODUCTS = {
    meno: {
      name: "Meno Balance",
      handle: "meno-balance",
      price: 24.99,
      gradient: "linear-gradient(135deg,#fbe1e8,#fdf3f5)",
      because: "Red Clover, Sage and Monk's Pepper for hormonal support, with KSM-66 Ashwagandha and B-vitamins to help steady mood and energy.<sup>*</sup>"
    },
    nad: {
      name: "NAD+ Jugendelixier",
      handle: "nad-jugendelixier",
      price: 24.99,
      gradient: "linear-gradient(135deg,#e0d4e8,#fdf3f5)",
      because: "A 12-ingredient NAD+ complex designed to support cellular energy and healthy aging from within.<sup>*</sup>"
    },
    magnesium: {
      name: "Magnesium Balance",
      handle: "magnesium-balance",
      price: 24.99,
      gradient: "linear-gradient(135deg,#d8d0e8,#fce8ef)",
      because: "500mg from 6 absorbable forms of magnesium, plus B6 and L-Theanine to help the body relax and the mind switch off.<sup>*</sup>"
    },
    collagen: {
      name: "Kollagen Elixier",
      handle: "kollagen-elixier",
      price: 24.99,
      gradient: "linear-gradient(135deg,#fdd9c8,#fbe1e8)",
      because: "6g hydrolysed collagen with hyaluronic acid, biotin, vitamin C and zinc — to support skin elasticity and stronger nails.<sup>*</sup>"
    },
    probiotic: {
      name: "Darm Balance Probiotikum",
      handle: "darm-balance-probiotikum",
      price: 23.99,
      gradient: "linear-gradient(135deg,#d9e8d6,#fdf3f5)",
      because: "35 billion CFU across 6 strains, with cranberry and D-mannose for vaginal and urinary comfort, plus zinc for immunity.<sup>*</sup>"
    },
    electrolyte: {
      name: "Electrolyt Essenz",
      handle: "electrolyt-essenz",
      price: 24.99,
      gradient: "linear-gradient(135deg,#d4e4ea,#fdf3f5)",
      because: "300mg sodium with B6 and magnesium — to hydrate without bloating and ease PMS-day discomfort.<sup>*</sup>"
    },
    detox: {
      name: "Detox Essenz",
      handle: "detox-essenz",
      price: 24.99,
      gradient: "linear-gradient(135deg,#cfe2d2,#fbf6f2)",
      because: "A daily-use blend designed to support your liver's natural detoxification pathways — for a lighter feel without anything harsh.<sup>*</sup>"
    },
    sleep: {
      name: "Schlaf Essenz",
      handle: "schlaf-essenz",
      price: 24.99,
      gradient: "linear-gradient(135deg,#c8c4dd,#fce8ef)",
      because: "A targeted formula for falling asleep faster and waking less — designed for women who can't switch off at night.<sup>*</sup>"
    }
  };

  // ----------------------------------------------------------
  // MERGE Liquid-injected product data (variantId, imageUrl, price, rating)
  // <script id="quiz-product-data" type="application/json"> in section
  // ----------------------------------------------------------
  try {
    var dataEl = document.getElementById("quiz-product-data");
    if (dataEl) {
      var liquidData = JSON.parse(dataEl.textContent);
      Object.keys(liquidData).forEach(function (key) {
        if (PRODUCTS[key]) {
          Object.assign(PRODUCTS[key], liquidData[key]);
        }
      });
    }
  } catch (e) {
    // fail silently — static data still works
  }

  // Override product name/because copy from FA_QUIZ_STRINGS (i18n)
  try {
    if (S.products) {
      Object.keys(S.products).forEach(function (k) {
        if (PRODUCTS[k]) {
          if (S.products[k].name)    PRODUCTS[k].name = S.products[k].name;
          if (S.products[k].because) PRODUCTS[k].because = S.products[k].because;
        }
      });
    }
  } catch (e) { /* keep static copy */ }

  // ----------------------------------------------------------
  // STATE — collected answers
  // ----------------------------------------------------------
  var state = {
    primary:   null,  // q1 — radio
    age:       null,  // q2 — radio
    secondary: [],    // q3 — checkbox (max 3)
    body:      [],    // q4 — checkbox
    size:      3,     // q5 — radio (number of products)
    flags:     []     // q6 — checkbox (safety flags)
  };

  // ----------------------------------------------------------
  // SCORING — turns answers into a ranked product list
  // ----------------------------------------------------------
  function scoreProducts() {
    var s = { meno:0, nad:0, magnesium:0, collagen:0, probiotic:0, electrolyte:0, detox:0, sleep:0 };

    // Q1 — primary concern (heavy weight, up to 5 pts)
    var primaryW = {
      hormones:  { meno:5, magnesium:2, nad:1 },
      sleep:     { magnesium:5, sleep:4, meno:1 },
      skin:      { collagen:5, nad:2, probiotic:1 },
      gut:       { probiotic:5, detox:2 },
      energy:    { nad:4, magnesium:3, electrolyte:2 },
      aging:     { nad:5, meno:2, collagen:2 },
      hydration: { electrolyte:5, magnesium:1 },
      detox:     { detox:5, probiotic:1 }
    };
    var pw = primaryW[state.primary] || {};
    Object.keys(pw).forEach(function (k) { s[k] += pw[k]; });

    // Q2 — age bias
    var ageW = {
      "under-25": { collagen:1, probiotic:1, magnesium:1, electrolyte:1 },
      "25-34":    { collagen:2, probiotic:1, magnesium:1, electrolyte:1 },
      "35-44":    { collagen:2, magnesium:2, nad:1, probiotic:1 },
      "45-54":    { meno:3, nad:2, magnesium:2, collagen:1 },
      "55+":      { meno:3, nad:3, magnesium:2, collagen:1 }
    };
    var aw = ageW[state.age] || {};
    Object.keys(aw).forEach(function (k) { s[k] += aw[k]; });

    // Q3 — secondary goals (lighter, 1-2 pts each)
    var secW = {
      hormones:  { meno:2, magnesium:1 },
      sleep:     { magnesium:2, sleep:1 },
      skin:      { collagen:2, nad:1 },
      gut:       { probiotic:2 },
      energy:    { nad:1, magnesium:1, electrolyte:1 },
      hydration: { electrolyte:2 },
      immunity:  { probiotic:2 },
      aging:     { nad:2, collagen:1 }
    };
    state.secondary.forEach(function (v) {
      var w = secW[v] || {};
      Object.keys(w).forEach(function (k) { s[k] += w[k]; });
    });

    // Q4 — body signs (small boost, 1-2 pts)
    var bodyW = {
      "cycle":       { meno:1 },
      "hot-flashes": { meno:2 },
      "mood":        { magnesium:1, meno:1 },
      "skin-signs":  { collagen:1, nad:1 },
      "bloating":    { probiotic:2, detox:1 },
      "cramps":      { magnesium:1, electrolyte:1 }
    };
    state.body.forEach(function (v) {
      var w = bodyW[v] || {};
      Object.keys(w).forEach(function (k) { s[k] += w[k]; });
    });

    // Q6 — safety flags BLOCK certain products
    if (state.flags.indexOf("pregnant") !== -1) {
      s.meno  = -999;
      s.detox = -999;
      s.nad   = -999;
      s.sleep = -999;
    }

    return s;
  }

  function pickRoutine() {
    var scores = scoreProducts();
    var ranked = Object.keys(scores)
      .filter(function (k) { return scores[k] > 0; })
      .map(function (k) { return { key: k, score: scores[k] }; })
      .sort(function (a, b) { return b.score - a.score; });

    var N = parseInt(state.size, 10) || 3;
    var safeFallbacks = ["magnesium", "collagen", "probiotic", "electrolyte"];

    if (ranked.length === 0) {
      return safeFallbacks.slice(0, N);
    }

    var picked = [];
    for (var i = 0; i < ranked.length && picked.length < N; i++) {
      picked.push(ranked[i].key);
    }
    if (picked.length < N) {
      for (var j = 0; j < safeFallbacks.length; j++) {
        if (picked.length >= N) break;
        var fb = safeFallbacks[j];
        if (picked.indexOf(fb) === -1 && scores[fb] > -999) picked.push(fb);
      }
    }
    return picked;
  }

  // ----------------------------------------------------------
  // REASONING — "why these for you" explainer
  // ----------------------------------------------------------
  function buildReasoning(picks) {
    var concernLabels = S.concern || {};
    var ageLabels     = S.age || {};
    var concernBit = concernLabels[state.primary] || concernLabels.fallback || "where you said you need most support";
    var ageBit     = ageLabels[state.age]          || ageLabels.fallback     || "at the stage you're in";

    var productNames = picks.map(function (k) { return PRODUCTS[k].name; });
    var productList = productNames.length === 1
      ? productNames[0]
      : productNames.slice(0, -1).join(", ") + " " + (S.list_and || "and") + " " + productNames[productNames.length - 1];

    var tpl = picks.length === 1
      ? (S.reasoning_single || "")
      : (S.reasoning_multi || "");
    var intro = tpl
      .replace("[age]", ageBit)
      .replace("[concern]", concernBit)
      .replace("[products]", productList);

    return '<div class="quiz-reasoning-card"><div class="quiz-reasoning-icon">why</div><div class="quiz-reasoning-body">' + intro + "</div></div>";
  }

  // ----------------------------------------------------------
  // SAFETY ALERT
  // ----------------------------------------------------------
  function buildAlert() {
    var f = state.flags;
    if (f.indexOf("pregnant") !== -1) {
      return S.alert_pregnant || "";
    }
    if (f.indexOf("medication") !== -1 || f.indexOf("condition") !== -1) {
      return S.alert_medication || "";
    }
    return null;
  }

  // ----------------------------------------------------------
  // FORMAT MONEY — €24,99 style
  // ----------------------------------------------------------
  function fmt(n) {
    return "€" + n.toFixed(2).replace(".", ",");
  }

  // ----------------------------------------------------------
  // RENDER RESULTS into DOM
  // ----------------------------------------------------------
  var currentPicks = [];

  function renderResults() {
    var picks = pickRoutine();
    currentPicks = picks;
    renderResultsFromPicks(picks);
  }

  function renderResultsFromPicks(picks) {
    var grid        = document.querySelector("[data-results-grid]");
    var reasoning   = document.querySelector("[data-reasoning]");
    var alertEl     = document.querySelector("[data-alert]");
    var alertTextEl = document.querySelector("[data-alert-text]");

    if (!grid) return;

    // Reasoning
    if (reasoning) reasoning.innerHTML = buildReasoning(picks);

    // Alert
    var alertMsg = buildAlert();
    if (alertEl && alertTextEl) {
      if (alertMsg) {
        alertEl.hidden = false;
        alertTextEl.innerHTML = alertMsg;
      } else {
        alertEl.hidden = true;
      }
    }

    // Cards
    grid.innerHTML = "";
    picks.forEach(function (key, i) {
      var p      = PRODUCTS[key];
      var isMain = (i === 0);
      var cardCls  = "quiz-result-card" + (isMain ? " quiz-result-card--main" : "");
      var chipCls  = isMain ? "chip chip-bestseller" : "chip chip-soft";
      var chipText = isMain ? (S.chip_foundation || "Foundation") : (S.chip_support || "Add to support");

      // Remove button — only shown when more than 1 pick remains
      var removeBtn = "";
      if (picks.length > 1) {
        var removeAria = (S.remove_aria || "Remove [name]").replace("[name]", p.name);
        removeBtn = '<button class="quiz-result-remove" data-remove-key="' + key + '" aria-label="' + removeAria + '">×</button>';
      }

      // Image — use Shopify product image if available, else gradient placeholder
      var imgHtml;
      if (p.imageUrl) {
        imgHtml = '<div class="quiz-result-img" style="background:' + p.gradient + ';" aria-hidden="true">' +
          '<img src="' + p.imageUrl + '" alt="' + p.name + '" loading="lazy" width="300" height="225">' +
          '</div>';
      } else {
        imgHtml = '<div class="quiz-result-img" style="background:' + p.gradient + ';" aria-hidden="true">' +
          '<span class="quiz-result-img-label">' + p.name + '</span>' +
          '</div>';
      }

      // Price display
      var priceDisplay = p.price ? fmt(p.price) : "";

      // Quick shop button — direct cart add
      var qsHandle = p.handle || key;
      var qsAria = (S.quick_shop_aria || "Quick shop [name]").replace("[name]", p.name);
      var qsBtn = '<button class="btn-quick" data-product-handle="' + qsHandle + '" aria-label="' + qsAria + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12"><path d="M12 5v14M5 12h14"/></svg>' +
        '<span class="btn-quick-label">' + (S.quick_shop || "Quick shop") + '</span>' +
        '</button>';

      var article = document.createElement("article");
      article.className = cardCls;
      article.dataset.quizResultKey = key;
      article.style.position = "relative";
      article.innerHTML =
        removeBtn +
        '<span class="' + chipCls + '">' + chipText + "</span>" +
        imgHtml +
        '<h3 class="h3">' + p.name + "</h3>" +
        '<p class="muted">' + p.because + "</p>" +
        '<div class="quiz-result-foot">' +
          '<strong>' + priceDisplay + "</strong>" +
          qsBtn +
        "</div>";

      grid.appendChild(article);
    });

    // Totals & savings
    var subtotal = picks.reduce(function (sum, k) { return sum + (PRODUCTS[k].price || 0); }, 0);
    var pct = 0;
    if (picks.length >= 4)      pct = 0.20;
    else if (picks.length >= 3) pct = 0.15;
    else if (picks.length >= 2) pct = 0.10;

    var save  = subtotal * pct;
    var final = subtotal - save;

    var countEl    = document.querySelector("[data-total-count]");
    var subtotalEl = document.querySelector("[data-total-subtotal]");
    var saveRow    = document.querySelector("[data-total-save-row]");
    var savePctEl  = document.querySelector("[data-total-save-pct]");
    var saveEl     = document.querySelector("[data-total-save]");
    var strikeEl   = document.querySelector("[data-total-strike]");
    var finalEl    = document.querySelector("[data-total-final]");
    var ctaPriceEl = document.querySelector("[data-total-cta-price]");

    if (countEl)    countEl.textContent    = picks.length;
    if (subtotalEl) subtotalEl.textContent = fmt(subtotal);

    if (saveRow) {
      if (pct > 0) {
        saveRow.style.display = "";
        if (savePctEl) savePctEl.textContent = (pct * 100).toFixed(0) + "%";
        if (saveEl)    saveEl.textContent    = "−" + fmt(save);
        if (strikeEl)  { strikeEl.textContent = fmt(subtotal); strikeEl.style.display = ""; }
      } else {
        saveRow.style.display = "none";
        if (strikeEl) strikeEl.style.display = "none";
      }
    }
    if (finalEl)    finalEl.textContent    = fmt(final);
    if (ctaPriceEl) ctaPriceEl.textContent = fmt(final);
  }

  // ----------------------------------------------------------
  // REMOVE PICK — removes a product from currentPicks and re-renders
  // ----------------------------------------------------------
  function removePick(key) {
    var idx = currentPicks.indexOf(key);
    if (idx === -1 || currentPicks.length <= 1) return;
    currentPicks.splice(idx, 1);
    renderResultsFromPicks(currentPicks);
  }

  // ----------------------------------------------------------
  // STEP NAVIGATION
  // ----------------------------------------------------------
  var steps       = document.querySelectorAll(".quiz-step");
  var progressEl  = document.querySelector("[data-quiz-progress]");
  var progressLabel = document.querySelector("[data-progress-label]");
  var progressPct   = document.querySelector("[data-progress-pct]");
  var progressFill  = document.querySelector("[data-progress-fill]");
  var prevBtn     = document.querySelector("[data-prev]");
  var nextBtn     = document.querySelector("[data-next]");
  var navEl       = document.querySelector("[data-quiz-nav]");
  var current     = 1;
  var TOTAL       = 6;

  function isStepValid(stepNum) {
    var step = document.querySelector(".quiz-step[data-step='" + stepNum + "']");
    if (!step) return false;
    return step.querySelectorAll("input:checked").length > 0;
  }

  function updateNextButton() {
    if (current === "results") return;
    if (nextBtn) nextBtn.disabled = !isStepValid(current);
  }

  function render() {
    steps.forEach(function (s) {
      s.dataset.active = String(
        s.dataset.step == current ||
        (current === "results" && s.dataset.step === "results")
      );
    });

    if (current === "results") {
      if (progressEl) progressEl.style.display = "none";
      if (navEl)      navEl.style.display = "none";
      window.scrollTo({ top: 0, behavior: "smooth" });
      renderResults();
    } else {
      if (progressEl) progressEl.style.display = "";
      if (navEl)      navEl.style.display = "";

      var pct = Math.round((current / TOTAL) * 100);
      if (progressLabel) progressLabel.textContent = (S.progress_label || "Step [step] of [total]").replace("[step]", current).replace("[total]", TOTAL);
      if (progressPct)   progressPct.textContent   = pct + "%";
      if (progressFill)  progressFill.style.width  = pct + "%";

      if (prevBtn) prevBtn.disabled = (current === 1);
      if (nextBtn) nextBtn.textContent = (current === TOTAL) ? (S.see_routine || "See my routine") : (S.continue || "Continue");
      updateNextButton();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function () {
      if (typeof current === "number" && current > 1) {
        current -= 1;
        render();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      if (nextBtn.disabled) return;
      if (typeof current === "number" && current < TOTAL) {
        current += 1;
        render();
      } else if (current === TOTAL) {
        current = "results";
        render();
      }
    });
  }

  // Re-check validity on any input change
  document.addEventListener("change", function (e) {
    if (e.target && e.target.matches(".quiz-step input")) {
      updateNextButton();
    }
  });

  // ----------------------------------------------------------
  // ANSWER COLLECTION
  // ----------------------------------------------------------
  // Single-select questions
  document.querySelectorAll("input[name='q1']").forEach(function (el) {
    el.addEventListener("change", function () { state.primary = el.dataset.value; });
  });
  document.querySelectorAll("input[name='q2']").forEach(function (el) {
    el.addEventListener("change", function () { state.age = el.dataset.value; });
  });
  document.querySelectorAll("input[name='q5']").forEach(function (el) {
    el.addEventListener("change", function () { state.size = parseInt(el.dataset.value, 10); });
  });

  // Multi-select handler with "clear others" support
  function bindMulti(name, stateKey, max) {
    var inputs = document.querySelectorAll("input[name='" + name + "']");
    inputs.forEach(function (el) {
      el.addEventListener("change", function () {
        if (el.checked && el.dataset.clearOthers === "true") {
          inputs.forEach(function (other) { if (other !== el) other.checked = false; });
        } else if (el.checked) {
          inputs.forEach(function (other) { if (other.dataset.clearOthers === "true") other.checked = false; });
        }
        if (max) {
          var sel = Array.from(inputs).filter(function (i) { return i.checked && i.dataset.clearOthers !== "true"; });
          if (sel.length > max) { el.checked = false; }
        }
        state[stateKey] = Array.from(inputs)
          .filter(function (i) { return i.checked && i.dataset.value !== "none"; })
          .map(function (i) { return i.dataset.value; });
      });
    });
  }
  bindMulti("q3", "secondary", 3);
  bindMulti("q4", "body", null);
  bindMulti("q6", "flags", null);

  // ----------------------------------------------------------
  // SAVE FORM (email newsletter — Shopify handles via Liquid form)
  // Mockup fallback for demo mode
  // ----------------------------------------------------------
  var saveForm = document.querySelector("[data-save-form]");
  if (saveForm) {
    saveForm.addEventListener("submit", function (e) {
      // Shopify form handles real submission; this is just UX feedback for JS-intercepted cases
      var btn = saveForm.querySelector("button[type='submit']");
      if (btn && saveForm.dataset.shopifyForm !== "true") {
        e.preventDefault();
        btn.textContent = "✓ " + (S.email_success || "Sent! Check your inbox.");
        btn.disabled = true;
        btn.style.background = "var(--green-500)";
      }
    });
  }

  // ----------------------------------------------------------
  // REMOVE × CLICK HANDLER
  // ----------------------------------------------------------
  document.addEventListener("click", function (e) {
    var removeBtn = e.target.closest("[data-remove-key]");
    if (!removeBtn) return;
    removePick(removeBtn.dataset.removeKey);
  });

  // ----------------------------------------------------------
  // QUICK SHOP — direct cart add, then open cart drawer
  // ----------------------------------------------------------
  document.addEventListener("click", function (e) {
    var qs = e.target.closest(".btn-quick[data-product-handle]");
    if (!qs || qs.disabled) return;
    var handle = qs.dataset.productHandle;
    var productKey = Object.keys(PRODUCTS).find(function (k) { return PRODUCTS[k].handle === handle; });
    var p = productKey ? PRODUCTS[productKey] : null;
    if (!p || !p.variantId) { window.location.href = "/products/" + handle; return; }
    qs.disabled = true;
    var origInner = qs.innerHTML;
    qs.textContent = "...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [{ id: p.variantId, quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) throw new Error("add failed");
      return res.json();
    }).then(function () {
      qs.disabled = false;
      qs.innerHTML = origInner;
      if (window.cartDrawer && typeof window.cartDrawer.open === "function") {
        window.cartDrawer.open();
      } else {
        document.dispatchEvent(new CustomEvent("feel:cart:open"));
      }
    }).catch(function () {
      qs.disabled = false;
      qs.innerHTML = origInner;
      window.location.href = "/products/" + handle;
    });
  });

  // ----------------------------------------------------------
  // CHECKOUT CTA — add all recommended items to cart, open drawer
  // ----------------------------------------------------------
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-to-bag]");
    if (!btn) return;
    if (currentPicks.length === 0) return;

    // Build items array with Shopify variantIds
    var items = currentPicks.reduce(function (arr, key) {
      var p = PRODUCTS[key];
      if (p && p.variantId) {
        arr.push({ id: p.variantId, quantity: 1 });
      }
      return arr;
    }, []);

    if (items.length === 0) {
      // fallback: redirect to bundle page
      window.location.href = "/pages/bundle";
      return;
    }

    btn.disabled = true;
    btn.textContent = S.adding || "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Cart add failed");
        return res.json();
      })
      .then(function () {
        // Open cart drawer — matches theme event pattern
        if (window.cartDrawer && typeof window.cartDrawer.open === "function") {
          window.cartDrawer.open();
        } else {
          document.dispatchEvent(new CustomEvent("feel:cart:open"));
        }
        btn.disabled = false;
        btn.innerHTML = (S.checkout_cta || "Proceed to checkout") + " &middot; <span data-total-cta-price>" + (document.querySelector("[data-total-cta-price]") ? document.querySelector("[data-total-cta-price]").textContent : "") + "</span>";
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = S.checkout_error || "Something went wrong — try again";
      });
  });

  // ----------------------------------------------------------
  // INIT
  // ----------------------------------------------------------
  render();

})();
